import { render, staticRenderFns } from "./adresaradialog.vue?vue&type=template&id=6189ec16&"
import script from "./adresaradialog.vue?vue&type=script&lang=js&"
export * from "./adresaradialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports